import { useUiPreferences } from '../useUiPreferences';
import { Section, SegmentedRow, SliderRow, ToggleRow } from '../SettingsRows';

const DEFAULTS = { 'ui.podcasts.auto_download': 'true', 'ui.podcasts.keep_days': '30', 'ui.podcasts.skip_intro': '15', 'ui.podcasts.speed': '1.0×' };

export function PodcastsTab(): React.JSX.Element {
    const [prefs, save] = useUiPreferences(DEFAULTS);

    return (
        <>
            <Section title="New episodes">
                <ToggleRow
                    label="Download automatically"
                    desc="Fetch new episodes as soon as they appear."
                    value={prefs['ui.podcasts.auto_download'] === 'true'}
                    onChange={(v) => save({ 'ui.podcasts.auto_download': String(v) })}
                />
                <SliderRow
                    label="Keep episodes for"
                    desc="Played episodes are removed after this."
                    min={7}
                    max={90}
                    step={1}
                    unit="days"
                    value={Number(prefs['ui.podcasts.keep_days']) || 7}
                    onChange={(v) => save({ 'ui.podcasts.keep_days': String(v) })}
                />
            </Section>
            <Section title="Playback">
                <SliderRow
                    label="Skip intro"
                    desc="Jump forward when an episode starts."
                    min={0}
                    max={60}
                    step={5}
                    unit="sec"
                    value={Number(prefs['ui.podcasts.skip_intro']) || 0}
                    onChange={(v) => save({ 'ui.podcasts.skip_intro': String(v) })}
                />
                <SegmentedRow
                    label="Default speed"
                    desc="Applied to every new episode."
                    options={['1.0×', '1.25×', '1.5×']}
                    value={prefs['ui.podcasts.speed']}
                    onChange={(v) => save({ 'ui.podcasts.speed': v })}
                />
            </Section>
        </>
    );
}
